import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: buybox;

  display: flex;
  flex-direction: column;

  gap: ${theme.spacings.giga};
`

export const Wrapper = styled('div')(wrapperStyles)
